(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-page-tabbing-collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  function initOwl(scope) {
    $(scope).find('.owl-carousel').owlCarousel({
      loop: true,
      margin: 15,
      nav: true,
      dots: false,
      responsive: {
        0: { items: 1 },
        600: { items: 3 },
        1000: { items: 4 }
      }
    });
  }

  initOwl(document);

  const buttons = document.querySelectorAll(".tab-btn");
  const contents = document.querySelectorAll(".tab-content");

  buttons.forEach(btn => {
    btn.addEventListener("click", function () {

      buttons.forEach(b => b.classList.remove("active"));
      contents.forEach(c => c.classList.remove("active"));

      this.classList.add("active");
      const activeTab = document.getElementById(this.dataset.tab);
      activeTab.classList.add("active");

      $(activeTab).find('.owl-carousel').trigger('refresh.owl.carousel');
    });
  });

});

  } catch(e) { console.error(e); }
})();
})();
